"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfHealthSettingsConverter = void 0;
class VcfHealthSettingsConverter {
    static convertVcfResponseToHealthReportSettings(vcfResponse) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const data = vcfResponse === null || vcfResponse === void 0 ? void 0 : vcfResponse.data;
        return {
            timeBased: {
                supported: (_a = data === null || data === void 0 ? void 0 : data.timeBasedSupported) !== null && _a !== void 0 ? _a : false,
                enabled: ((_b = data === null || data === void 0 ? void 0 : data.timeBased) === null || _b === void 0 ? void 0 : _b.collectionPeriod) === 'monthly',
                interval: this.fallbackToFirstElementIfNotInRange((_c = data === null || data === void 0 ? void 0 : data.timeBased) === null || _c === void 0 ? void 0 : _c.monthsBetweenReports, 3, 1),
                dayOfMonth: this.fallbackToFirstElementIfNotInRange((_d = data === null || data === void 0 ? void 0 : data.timeBased) === null || _d === void 0 ? void 0 : _d.dayOfMonth, 31, 1)
            },
            distanceBased: {
                supported: (_e = data === null || data === void 0 ? void 0 : data.distanceBasedSupported) !== null && _e !== void 0 ? _e : false,
                enabled: ((_g = (_f = data === null || data === void 0 ? void 0 : data.distanceBased) === null || _f === void 0 ? void 0 : _f.distance_km) !== null && _g !== void 0 ? _g : 0) !== 0,
                interval: this.fallbackToFirstElementIfNotInRange((_h = data === null || data === void 0 ? void 0 : data.distanceBased) === null || _h === void 0 ? void 0 : _h.distance_km, 10, 1000)
            },
            maintenanceBased: {
                supported: (_j = data === null || data === void 0 ? void 0 : data.maintenanceBasedSupported) !== null && _j !== void 0 ? _j : false,
                enabled: ((_l = (_k = data === null || data === void 0 ? void 0 : data.maintenanceBased) === null || _k === void 0 ? void 0 : _k.distance_km) !== null && _l !== void 0 ? _l : 0) !== 0,
                interval: this.fallbackToFirstElementIfNotInRange((_m = data === null || data === void 0 ? void 0 : data.maintenanceBased) === null || _m === void 0 ? void 0 : _m.distance_km, 10, 1000)
            }
        };
    }
    static convertHealthReportSettingsToVcfData(healthReportSettings) {
        return {
            timeBased: {
                collectionPeriod: healthReportSettings.timeBased.enabled ? 'monthly' : 'none',
                dayOfMonth: healthReportSettings.timeBased.dayOfMonth,
                monthsBetweenReports: healthReportSettings.timeBased.interval
            },
            distanceBased: {
                distance_km: healthReportSettings.distanceBased.enabled ? healthReportSettings.distanceBased.interval : 0
            },
            maintenanceBased: {
                distance_km: healthReportSettings.maintenanceBased.enabled ? healthReportSettings.maintenanceBased.interval : 0
            }
        };
    }
    static fallbackToFirstElementIfNotInRange(value, numberOf, increment) {
        const values = Array.from(Array(numberOf).keys(), x => (x + 1) * increment);
        return value && values.includes(value) ? value : values[0];
    }
}
exports.VcfHealthSettingsConverter = VcfHealthSettingsConverter;
//# sourceMappingURL=VcfHealthSettingsConverter.js.map